import React, { useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { PORTAL_URL } from "../Constants";
import '../i18n';
import { useTranslation } from 'react-i18next'
//react-i18next';

const Header = () => {
    const headerRef = useRef(null);
    const { t, i18n } = useTranslation();
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
  };
    useEffect(() => {
        const updateMarginTop = () => {
            const headerHeight = (headerRef.current?.offsetHeight || 0) + 40; // Get header height
            const elements = document.querySelectorAll(".custom-margin-top"); // Select elements to apply margin
            elements.forEach((element) => {
                element.style.marginTop = `${headerHeight}px`; // Apply margin
                element.style.useTranslation = `margin-top 0.3s ease`; // Apply margin
            });
        };

        updateMarginTop(); // Initial call

        // Add event listener for window resize
        window.addEventListener("resize", updateMarginTop);

        return () => {
            // Cleanup on component unmount
            window.removeEventListener("resize", updateMarginTop);
        };
    }, []);



    return (
        <>
            <div className="bs-header">
                <div className="navbar top-row fixed-top " style={{ zIndex: 10000001, height: 40,paddingTop:0 }}>
                    <div className="container-fluid d-flex justify-content-between align-items-center p-1" style={{fontSize:"0.85rem" , background:"#eaf7fe"}}>
                     
                        <div className="d-flex gap-2">
                            <a href="/" className="text-dark text-decoration-none">{t('home')}</a> |
                            <a href="/resource#faq" className="text-dark text-decoration-none">{t('faq')}</a> 
                        </div>

                      
                        <div className="d-flex align-items-center gap-3 mr-5" style={{marginRight:`1rem`}}>
                           
                           
                                {/* <p>{t('welcome')}</p> */}
                                {/* <p>{t('greeting', { name: 'John' })}</p> */}

                                <button style={{
                                        padding: '0.15rem 0.3rem',
                                        fontSize: '0.65rem',
                                        lineHeight: 1,
                                        borderRadius: '0.2rem',
                                    }} 
                                    className={i18n.language === 'en' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-primary'} onClick={() => changeLanguage('en')}>English</button>
                                <button style={{
                                    padding: '0.15rem 0.3rem',
                                    fontSize: '0.65rem',
                                    lineHeight: 1,
                                    borderRadius: '0.2rem',
                                }} 
                                className={i18n.language === 'mr' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-primary'} onClick={() => changeLanguage('mr')}>मराठी</button>
                                      
                        </div>
                    </div>
                </div>
                <nav
                    className="navbar navbar-expand-xl  pt-1 pb-1 pl-5 pr-5"
                    ref={headerRef}
                    id="header"
                    style={{ zIndex: 10000001, position: "fixed", top: 40,width:"100%" }}
                >

                    <div className="container-fluid">
                        <Link to="/" className="navbar-brand">
                            <img
                                className="img-fluid"
                                src="/images/logo-svg.svg"
                                alt="logo"
                                width={50}
                                height={50}
                            />
                            <p className="bs-para">
                                Griharmony Redevelopment <br /> Stakeholders
                                Federation
                            </p>
                        </Link>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            aria-controls="offcanvasNavbar"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div
                            className="offcanvas offcanvas-end"
                            tabIndex="-1"
                            id="offcanvasNavbar"
                            aria-labelledby="offcanvasNavbarLabel"
                        >
                            <div className="offcanvas-header">
                                <h5
                                    className="offcanvas-title"
                                    id="offcanvasNavbarLabel"
                                >
                                    <Link to="/" className="navbar-brand">
                                        <img
                                            className="img-fluid"
                                            src="/images/logo-svg.svg"
                                            alt="logo"
                                            width={50}
                                            height={50}
                                        />
                                    </Link>
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="offcanvas-body">
                                <ul className="navbar-nav justify-content-end flex-grow-1 ">
                                    <li className="nav-item dropdown custom-dropdown">
                                        <Link className="nav-link" to="/">
                                            {t('home')}
                                        </Link>
                                        <div className="dropdown">
                                            <button
                                                className="dropdown-toggle dropdown-toggle-split caretbtn"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <span className="visually-hidden">
                                                    Toggle Dropdown
                                                </span>
                                            </button>
                                            <ul
                                                className="dropdown-menu customTop"
                                                aria-labelledby="mediaPage"
                                            >
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="/#impupd"
                                                    >
                                                          {t('importantUpdate')}
                                                     
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="#lookfred"
                                                    >
                                                        {t('lookingForRedevelopment')}
                                                        
                                                    </a>
                                                </li>

                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="/#grsfnews"
                                                    >
                                                         {t('grsfInTheNews')}
                                                        
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="/#swoffr"
                                                    >
                                                        {t('serviceWeOffer')}
                                                        
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="/#evhligt"
                                                    >
                                                        {t('eventHighlight')}
                                                        
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="/#faqh"
                                                    >
                                                        {t('faq')}
                                                        
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="/#connectgrsf"
                                                    >{t('connectWithGRSF')}
                                                        
                                                    </a>
                                                </li>


                                            </ul>
                                        </div>
                                    </li>
                                    <li className="nav-item dropdown custom-dropdown">
                                        <Link
                                            className="nav-link"
                                            to="/about-us"
                                        >
                                              {t('aboutUs')}
                                            
                                        </Link>
                                        <div className="dropdown">
                                        <button
                                            className="dropdown-toggle dropdown-toggle-split caretbtn"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <span className="visually-hidden">
                                                Toggle Dropdown
                                            </span>
                                        </button>
                                        <ul
                                            className="dropdown-menu customTop"
                                            aria-labelledby="mediaPage"
                                        >
                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/about-us#wcgrsf"
                                                >
                                                    {t('whyChooseRSF')}
                                                    
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/about-us#ourm"
                                                >
                                                    {t('ourMethodology')}
                                                    
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/about-us#mission"
                                                >{t('ourMission')}
                                                   
                                                </a>
                                            </li>

                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/about-us#founders"
                                                >{t('ourFounders')}
                                                  
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/about-us#institutional"
                                                >
                                                    {t('institutionalMember')}
                                                    
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/about-us#directors"
                                                >
                                                    {t('ourDirectors')}
                                                
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/about-us#community"
                                                >
                                                     {t('ourCommunity')}
                                                  
                                                </a>
                                            </li>

                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/about-us#connectgrsf"
                                                >
                                                     {t('connectWithGRSF')}                                                   
                                                </a>
                                            </li>


                                        </ul>
                                        </div>
                                    </li>
                                    <li className="nav-item dropdown custom-dropdown">
                                        <Link
                                            className="nav-link"
                                            to="/service"
                                            id="servicePage"
                                        >
                                            {t('ourServices')}
                                          
                                        </Link>
                                        
                                    </li>
                                    <li className="nav-item dropdown custom-dropdown">
                                        <Link
                                            className="nav-link"
                                            to="/resource"
                                            id="mediaPage"
                                        >
                                            {t('resources')}
                                            
                                        </Link>
                                        <button
                                            className="dropdown-toggle dropdown-toggle-split caretbtn"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <span className="visually-hidden">
                                                Toggle Dropdown
                                            </span>
                                        </button>
                                        <ul
                                            className="dropdown-menu customTop"
                                            aria-labelledby="mediaPage"
                                        >
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to="/media"
                                                >
                                                    {t('mediaAndNews')}
                                                    
                                                </Link>
                                            </li>
                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/resource#resholist"
                                                >
                                                    {t('resourceList')}
                                                  
                                                </a>
                                            </li>

                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href="/resource#faq"
                                                >
                                                    {t('faq')}
                                                  
                                                </a>
                                            </li>


                                        </ul>
                                    </li>
                                    <li className="nav-item dropdown custom-dropdown highlight">
                                        <Link
                                            className="nav-link "
                                            to="/future-events"
                                            id="mediaPage"
                                            
                                        >
                                          <p className="highlight">  {t('upcomingEvents')} </p>
                                        </Link>
     
                                    </li>
                                </ul>
                                <div className="btn-section">
                                    <a
                                        className="bs-btn "
                                        href={PORTAL_URL}
                                        aria-label="Navigate to Login"
                                        target='_blank'

                                    >
                                       {t('login')} 
                                        <span className="icon icon-right-arrow"></span>
                                    </a>
                                    <Link
                                        className="bs-btn typfill"
                                        to="/contact-us"
                                        aria-label="Navigate to Contact Us"
                                    >
                                        {t('contactUs')}
                                       
                                        <span className="icon icon-right-arrow"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </nav>
            </div>
        </>
    );
};

export default Header;
